import { useQueries, useQuery } from "react-query";
import { useCurrentUser } from "../misc/useUser";
import { APIGetAvailableFranchises } from "../../service/api/multiFranchise/APIMultiFranchise";
import {
  canReadPendingRequests,
  combinePendingCounts,
  pendingRequestQuery,
} from "./requestPendingCount";

export function useRequestPendingCount() {
  const user = useCurrentUser();
  const enabled = canReadPendingRequests(user);
  const identity = JSON.stringify([user.username, user.company_uuid]);
  const franchises = useQuery(
    ["request-center-badge-franchises", identity],
    APIGetAvailableFranchises,
    {
      enabled,
      retry: 1,
      staleTime: 15000,
      refetchInterval: 30000,
      refetchIntervalInBackground: false,
    }
  );
  const ids =
    enabled && franchises.isSuccess
      ? [...new Set((franchises.data || []).map((f) => f.uuid))].sort()
      : [];
  const results = useQueries(ids.map((uuid) => pendingRequestQuery(uuid, identity)));
  const combined = combinePendingCounts(results);
  return {
    count: enabled && franchises.isSuccess ? combined.count : undefined,
    isError: enabled && (franchises.isError || combined.isError),
  };
}
